"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const any_to_near_1 = require("./any-to-near");
class AnyToNearTestnetPaymentNetwork extends any_to_near_1.default {
    constructor(currencyManager) {
        // testnet PN version is the same as mainnet, can be overridden here if needed
        super(currencyManager, ['aurora-testnet', 'near-testnet']);
    }
    /**
     * Check if a near testnet address is valid
     *
     * @param {string} address address to check
     * @returns {boolean} true if address is valid
     */
    isValidAddress(address) {
        return this.isValidAddressForSymbolAndNetwork(address, 'NEAR-testnet', 'aurora-testnet');
    }
}
exports.default = AnyToNearTestnetPaymentNetwork;
